import React from 'react';
import { connect } from 'react-redux';
import IndexQuickLook from 'components/shared/index/quicklook';
import { Icon } from 'ui';
import IndexTableBodyCell from '../../../../shared/index/table/body_cell';
import RoleTag from '../../../../shared/role_tag';
import * as indexActions from '../../../../../actions/shared/index/filter';
import {
  userGroupsSelector,
  userRoleSelector,
  canEditGroups,
} from '../../../../../selectors';
import { pluralize } from '../../../../../utils/string_utils';

const linkifyGroup = group => ({ ...group, url: `?groups[]=${group.id}` });

const PeopleTitleCell = ({
  name,
  urls,
  type,
  usersCount,
  users,
  description,
  groups,
  userGroups,
  role,
  filterByGroup,
  canEditPeople,
}) => (
  <IndexTableBodyCell size="xl" name="name" split>
    <div>
      <a className="Index-tablePrimaryField" href={urls.overview}>
        {name}
      </a>
      <div className="Index-tableSecondaryField">
        {type === 'group' && (
          <span>{`${users} ${pluralize(users, 'User', 'Users')}`}</span>
        )}
        {type === 'user' && (
          <div>
            <RoleTag {...role} />
          </div>
        )}
        {!_.isEmpty(userGroups) && (
          <IndexQuickLook
            data={userGroups.map(linkifyGroup)}
            valueKey="name"
            label={{ plural: 'Groups', singular: 'Group' }}
            icon="group"
            onItemClick={filterByGroup}
          />
        )}
      </div>
    </div>
    <div className="IndexAction-container">
      {canEditPeople && urls.edit && (
        <a
          className="IndexAction-button IndexAction-button--square"
          target="blank"
          href={urls.edit}
        >
          <Icon name="edit" />
        </a>
      )}
    </div>
  </IndexTableBodyCell>
);

const mapStateToProps = () => {
  const getGroups = userGroupsSelector();
  const getRole = userRoleSelector();
  return (state, { role, groups, type }) => ({
    role: type === 'user' && getRole(state, role),
    userGroups: type === 'user' && getGroups(state, groups),
    canEditPeople: canEditGroups(state),
  });
};

const mapDispatchToProps = dispatch => ({
  filterByGroup(id) {
    dispatch(indexActions.filterByGroup(id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleTitleCell);
